import { render, staticRenderFns } from "./NeuerTerminPage.vue?vue&type=template&id=61b927d6&scoped=true&"
import script from "./NeuerTerminPage.vue?vue&type=script&lang=ts&"
export * from "./NeuerTerminPage.vue?vue&type=script&lang=ts&"
import style0 from "./NeuerTerminPage.vue?vue&type=style&index=0&id=61b927d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b927d6",
  null
  
)

export default component.exports